import paper from "paper";
import {nanoid} from 'nanoid';
import {
  IPoint,
  ISize,
  SimpleMusicPaperShape,
  SimpleShapeSchemeType,
  ComplexMusicPaperShape,
  ComplexShapeSchemeType,
} from '@consts/types';
import palettes from '@consts/palettes';
import createColor from '@utils/create-color';

const INIT_POINT: IPoint = {
  x: 150,
  y: 150
}

const INIT_SIZE: ISize = {
  width: 200,
  height: 200
}

const COMPLEX_SHAPE_INIT_POINT_COUNT = 10;
const firstPaletteKey = palettes.default.key;

export const createSimpleMusicShape = (musicShapeType: SimpleShapeSchemeType): SimpleMusicPaperShape => ({
  id: nanoid(),
  type: musicShapeType,
  track: {
    SoundPaletteKey: firstPaletteKey,
    soundPosition: []
  },
  color: createColor(),
  shapeScheme: {
    point: { ...INIT_POINT },
    size: { ...INIT_SIZE }
  }
})

// TODO: temporary decision with use paper.Point, refactor when free time exist
export const createComplexMusicShape = (musicShapeType: ComplexShapeSchemeType): ComplexMusicPaperShape => {
  const centerPoint = { ...INIT_POINT };
  // centerPoint.x += Math.round(INIT_SIZE.width/2);
  // centerPoint.y += Math.round(INIT_SIZE.height/2);

  const corePoint = new paper.Point(centerPoint);
  const pointArr: IPoint[] = [];

  for (let i = 0; i < COMPLEX_SHAPE_INIT_POINT_COUNT; i++) {
    const delta = new paper.Point({
      length: (0.5) + (Math.random() * 0.25),
      angle: (360 / COMPLEX_SHAPE_INIT_POINT_COUNT) * i
    });

    const { x, y } = corePoint.multiply(delta);

    // TODO: Find decision with complex shape position and rewrite this part
    const totalX = x + Math.floor(INIT_POINT.x * 1.7);
    const totalY = y + Math.floor(INIT_POINT.y * 1.7);

    pointArr.push({ x: totalX, y: totalY });
  }

  return {
    id: nanoid(),
    type: musicShapeType,
    track: {
      SoundPaletteKey: firstPaletteKey,
      soundPosition: []
    },
    color: createColor(),
    shapeScheme: {
      points: pointArr
    }
  }
}

